(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  function syncNavbarMainBg() {
    var nav = document.querySelector('header[data-site-header] .navbar-main');
    if (!nav) return;
    if (window.scrollY <= 1) {
      nav.style.backgroundColor = '#fff';
    } else {
      nav.style.backgroundColor = '';
    }
  }
  function init() {
    syncNavbarMainBg();
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          syncNavbarMainBg();
        });
      },
      { passive: true }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-customer-photoes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-customer-photos-slider]').forEach(function (section) {
    var track = section.querySelector('[data-slider-track]');
    var prev = section.querySelector('.customer-photos-slider-arrow.prev');
    var next = section.querySelector('.customer-photos-slider-arrow.next');

    if (!track || !prev || !next) return;

    function scrollByCard(direction) {
      var firstSlide = track.querySelector('.customer-photos-slide');
      var amount = firstSlide ? firstSlide.getBoundingClientRect().width + 16 : 280;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      scrollByCard(-1);
    });

    next.addEventListener('click', function () {
      scrollByCard(1);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
